"use client"

import type React from "react"
import { memo } from "react"
import type { SyncOption } from "../../../types/choose-sync"
import SyncOptionCard from "./SyncOptionCard"

interface SyncOptionsListProps {
  options: SyncOption[]
  selectedOption: string | null
  onSelectOption: (optionId: string) => void
}

const SyncOptionsList: React.FC<SyncOptionsListProps> = memo(({ options, selectedOption, onSelectOption }) => (
  <div className="sync-options">
    {options.map((option) => (
      <SyncOptionCard
        key={option.id}
        option={option}
        isSelected={selectedOption === option.id}
        onSelect={onSelectOption}
      />
    ))}
  </div>
))

SyncOptionsList.displayName = "SyncOptionsList"

export default SyncOptionsList
